import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { copy } from '../data/teknik';
export const CHECKOUT_URL = 'https://krle-klar.impultienda.ar/checkout';
const UTM_STORAGE_KEY = 'krle-klar_utm_params';

// Pasa los parámetros de la URL de la landing (location.search: utm_*, fbclid, etc.) al link de checkout
function getTrackingParams(): URLSearchParams {
  if (typeof window === 'undefined') return new URLSearchParams();
  const current = new URLSearchParams(window.location.search);
  try {
    if (Array.from(current.keys()).length > 0) {
      sessionStorage.setItem(UTM_STORAGE_KEY, current.toString());
      return current;
    }
    const saved = sessionStorage.getItem(UTM_STORAGE_KEY);
    if (saved) return new URLSearchParams(saved);
  } catch {
    // sessionStorage bloqueado: seguimos con lo que haya en la URL
  }
  return current;
}
export function withTracking(href: string): string {
  if (href.startsWith('#')) return href;
  const params = getTrackingParams();
  if (Array.from(params.keys()).length === 0) return href;
  const url = new URL(href);
  params.forEach((value, key) => {
    if (!url.searchParams.has(key)) url.searchParams.set(key, value);
  });
  return url.toString();
}
type CtaButtonProps = {
  label?: string;
  href?: string;
  className?: string;
};
export function CtaButton({
  label = copy.ctaDefault,
  href = CHECKOUT_URL,
  className = ''
}: CtaButtonProps) {
  const isInternal = href.startsWith('#');
  const finalHref = isInternal ? href : withTracking(href);
  return <a href={finalHref} onClick={isInternal ? undefined : e => {
    e.currentTarget.href = withTracking(href);
  }} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} className={`group inline-flex items-center justify-center gap-2.5 whitespace-nowrap rounded-full bg-red-700 px-5 py-4 text-center text-sm font-semibold text-white shadow-lg shadow-red-700/30 transition-[transform,background-color] duration-150 ease-out hover:bg-red-800 active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-red-700/30 sm:px-9 sm:py-5 sm:text-base ${className}`} data-id="element-60" data-mp="3swapyowyzp94">
      <span data-id="element-61" data-mp="3i07772llulr5">{label}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-62" data-mp="hw2i3s267kg" />
    </a>;
}